import { FunctionComponent, useMemo } from 'react'

import { Icons } from 'atoms'
import { Button, HStack, Menu, ScrollView, Text, useDisclose } from 'native-base'

export type YearMonthOption = {
  label: string
  value: string
}

type YearMonthFilterProps = {
  onChange?(value: string): void
  options: YearMonthOption[]
  value?: string
  isDisabled?: boolean
}

export const YearMonthFilter: FunctionComponent<YearMonthFilterProps> = ({
  onChange,
  options,
  value,
  isDisabled = false
}) => {
  const selectedOption = useMemo(() => {
    if (!options?.length) return undefined

    return options.find((option) => option.value === value) ?? options[0]
  }, [options, value])

  const { isOpen, onClose, onOpen } = useDisclose(false)

  return (
    <Menu
      isOpen={isOpen}
      placement={undefined}
      onClose={onClose}
      minH={100}
      w="100%"
      flex={0}
      mt={4}
      py={4}
      bgColor="white"
      borderRadius={20}
      trigger={(triggerProps) => {
        delete triggerProps.onPress

        return (
          <Button
            onPress={onOpen}
            isDisabled={isDisabled}
            px={6}
            _text={{
              fontSize: '16px'
            }}
            h={10}
            _hover={{
              bgColor: 'primary.50',
              _text: {
                color: 'primary.500'
              }
            }}
            colorScheme={value ? 'primary-light' : 'white'}
            rightIcon={<Icons.ArrowDropDown color={value ? 'primary.500' : 'gray.500'} size={5} />}
            size="sm"
            {...triggerProps}>
            {selectedOption?.label ?? 'Ano/Mês'}
          </Button>
        )
      }}>
      <ScrollView py={4} maxH="30vh">
        {options.map((option, index) => {
          const isSelected = option.value === selectedOption?.value

          return (
            <Menu.Item
              key={option.label}
              backgroundColor={isSelected ? 'gray.50' : 'white'}
              _pressed={{ backgroundColor: 'gray.50' }}
              _hover={{ backgroundColor: 'gray.50' }}
              w="100%"
              px={8}
              py={2}
              borderBottomWidth="1px"
              borderTopWidth={index === 0 ? '1px' : '0px'}
              borderColor="gray.50"
              onPress={() => onChange?.(option.value)}>
              <HStack>
                <Text fontSize="16px" lineHeight="24px" color="gray.500">
                  {option.label}
                </Text>
              </HStack>
            </Menu.Item>
          )
        })}
      </ScrollView>
    </Menu>
  )
}
